import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M3 6V5c0-1.1.9-2 2-2h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11 3h3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 3h1c1.1 0 2 .9 2 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 9v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 15c0 1.1-.9 2-2 2h-1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 17h-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m7 17-4 4v-5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 12v-2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "MessageSquareDashed";
const MessageSquareDashed = memo(themed(Icon));
export {
  MessageSquareDashed
};
//# sourceMappingURL=message-square-dashed.js.map
